import React from 'react';

/**
 * TeacherFilterBar
 * Unified search and dropdown filter card for the header.
 */
export const TeacherFilterBar = ({
  search,
  onSearch,
  languages = [],
  countries = [],
  specialties = [],
  activeLanguage,
  onLanguage,
  activeCountry,
  onCountry,
  activeSpecialty,
  onSpecialty,
  activeAvailability,
  onAvailability,
  sortBy,
  onSortBy,
  onClear,
}) => {
  const [localSearch, setLocalSearch] = React.useState(search);

  // Sync local search with external state
  React.useEffect(() => {
    setLocalSearch(search);
  }, [search]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    onSearch(localSearch);
  };

  return (
    <div className="tp-filter-card">
      <form onSubmit={handleSearchSubmit} className="tp-filter-card__search-row">
        <div className="tp-filter-card__search-input-wrap">
          <i className="bi bi-search search-icon" />
          <input
            type="text"
            className="tp-filter-card__search-input"
            placeholder="Search teachers by name, language or country..."
            value={localSearch}
            onChange={(e) => setLocalSearch(e.target.value)}
          />
        </div>
        <button type="submit" className="tp-filter-card__search-btn">
          Search
        </button>
      </form>

      <div className="tp-filter-card__grid">
        {/* Language select */}
        <div className="tp-filter-card__select-group">
          <label className="tp-filter-card__label">Language</label>
          <select
            value={activeLanguage}
            onChange={(e) => onLanguage(e.target.value)}
            className="tp-filter-card__select"
          >
            <option value="">All Languages</option>
            {languages.map((lang) => (
              <option key={lang} value={lang}>
                {lang}
              </option>
            ))}
          </select>
        </div>

        {/* Country select */}
        <div className="tp-filter-card__select-group">
          <label className="tp-filter-card__label">Country</label>
          <select
            value={activeCountry}
            onChange={(e) => onCountry(e.target.value)}
            className="tp-filter-card__select"
          >
            <option value="">All Countries</option>
            {countries.map((c) => {
              const name = typeof c === 'string' ? c : c.value || c.label;
              return (
                <option key={name} value={name}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>

        {/* Specialties select */}
        <div className="tp-filter-card__select-group">
          <label className="tp-filter-card__label">Specialties</label>
          <select
            value={activeSpecialty}
            onChange={(e) => onSpecialty(e.target.value)}
            className="tp-filter-card__select"
          >
            <option value="">All Specialties</option>
            {specialties.map((spec) => (
              <option key={spec} value={spec}>
                {spec}
              </option>
            ))}
          </select>
        </div>

        {/* Availability select */}
        <div className="tp-filter-card__select-group">
          <label className="tp-filter-card__label">Availability</label>
          <select
            value={activeAvailability}
            onChange={(e) => onAvailability(e.target.value)}
            className="tp-filter-card__select"
          >
            <option value="">All Availability</option>
            <option value="online">Online Now</option>
            <option value="away">Away</option>
          </select>
        </div>

        {/* Sort by select */}
        <div className="tp-filter-card__select-group select-sort">
          <label className="tp-filter-card__label">Sort by</label>
          <select
            value={sortBy}
            onChange={(e) => onSortBy(e.target.value)}
            className="tp-filter-card__select"
          >
            <option value="Most Popular">Popularity</option>
            <option value="Highest Rated">Highest Rated</option>
            <option value="Newest">Newest</option>
            <option value="Price: Low to High">Price: Low to High</option>
            <option value="Price: High to Low">Price: High to Low</option>
          </select>
        </div>

        {/* Filter settings button */}
        <div className="tp-filter-card__settings-group">
          <button
            type="button"
            className="tp-filter-card__settings-btn"
            onClick={onClear}
            title="Reset Filters"
          >
            <i className="bi bi-sliders" />
          </button>
        </div>
      </div>
    </div>
  );
};
